var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.497 50.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#f16a73;}.cls-3{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text_Generator",
    "data-name": "Text Generator"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 25.249,
    cy: 25.249,
    r: 25.249
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.527,33.665a2.515,2.515,0,0,1-2.5-2.525V21a2.516,2.516,0,0,1,2.5-2.487H31.842A2.515,2.515,0,0,1,34.338,21V31.14a2.514,2.514,0,0,1-2.5,2.525ZM17.7,31.14a.841.841,0,0,0,.832.841H31.842a.841.841,0,0,0,.832-.841V22.657l-7.012,4.966a.825.825,0,0,1-.955,0L17.7,22.657Zm7.49-5.236,7.4-5.239a.837.837,0,0,0-.744-.466H18.528a.837.837,0,0,0-.744.466Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a17a44e71808ce748bdf44941a172f47.svg";
export { ForwardRef as ReactComponent };